import { SDKRequest, DiscordCommand } from '../../../../../../shared/DiscordActivityTypes.ts';
import { DiscordInviteShareHelper } from '../../../../../shared/scripts/discord/DiscordInviteShareHelper.ts';
import { SDKRequestValidateAction } from './SDKRequestValidateAction.ts';
import { ColonistCoinProduct } from '../../../../../../shared/store/ColonistCoinProduct.ts';
import { ColonistMembershipProduct } from '../../../../../../shared/store/ColonistMembershipProduct.ts';
import { ColonistOneTimePurchaseProduct } from '../../../../../../shared/store/ColonistOneTimePurchaseProduct.ts';
export class SDKRequestHandler {
    processSDKRequest(sdkRequest, data) {
        const validator = new SDKRequestValidateAction(sdkRequest, data);
        if (!validator.isValid) return;
        this.handleSDKRequest(validator);
    }
    handleSDKRequest(sdkRequest) {
        switch(sdkRequest.type){
            case SDKRequest.PurchaseMembership:
                this.purchaseMembership(sdkRequest.data);
                break;
            case SDKRequest.PurchaseGift:
                this.purchaseGift(sdkRequest.data);
                break;
            case SDKRequest.PurchaseCoins:
                this.purchaseCoins(sdkRequest.data);
                break;
            case SDKRequest.InviteFriends:
                this.inviteFriends();
                break;
            case SDKRequest.ShareMoment:
                this.shareMoment(sdkRequest.data);
                break;
            case SDKRequest.OpenExternalLink:
                this.openExternalLink(sdkRequest.data);
                break;
            case SDKRequest.ShareActivityLink:
                void this.shareActivityLink(sdkRequest.data);
                break;
            default:
                throw new Error('Invalid SDK Request');
        }
    }
    purchaseMembership(membershipType) {
        const membershipProduct = ColonistMembershipProduct.getMembershipProduct(membershipType);
        void this.contentFrameCommunicationHandler.sendMessageToMount({
            command: DiscordCommand.Purchase,
            data: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                sku_id: membershipProduct.discordSKUId
            }
        });
    }
    purchaseGift(oneTimePurchaseType) {
        const oneTimePurchaseProduct = ColonistOneTimePurchaseProduct.getOneTimePurchaseProduct(oneTimePurchaseType);
        void this.contentFrameCommunicationHandler.sendMessageToMount({
            command: DiscordCommand.Purchase,
            data: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                sku_id: oneTimePurchaseProduct.discordSKUId
            }
        });
    }
    purchaseCoins(coinType) {
        const coinProduct = ColonistCoinProduct.getPurchaseProduct(coinType);
        void this.contentFrameCommunicationHandler.sendMessageToMount({
            command: DiscordCommand.Purchase,
            data: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                sku_id: coinProduct.discordSKUId
            }
        });
    }
    inviteFriends() {
        DiscordInviteShareHelper.inviteFriends(this.contentFrameCommunicationHandler);
    }
    shareMoment(file) {
        void this.contentFrameCommunicationHandler.sendMessageToMount({
            command: DiscordCommand.ShareMoment,
            data: {
                imageFile: file
            }
        });
    }
    openExternalLink(url) {
        this.contentFrameCommunicationHandler.openExternalLink(url);
    }
    async shareActivityLink(data) {
        await DiscordInviteShareHelper.shareActivityLink(this.contentFrameCommunicationHandler, data);
    }
    static sendShareActivityLinkAnalytic(analyticType) {
        DiscordInviteShareHelper.sendShareActivityLinkAnalytic(analyticType);
    }
    constructor(contentFrameCommunicationHandler){
        this.contentFrameCommunicationHandler = contentFrameCommunicationHandler;
    }
}
